var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinIconsLinkOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64631 11.2341C4.0993 11.7811 3.79199 12.523 3.79199 13.2966C3.79199 14.0701 4.0993 14.812 4.64631 15.3591C5.19332 15.9061 5.93522 16.2134 6.70881 16.2134C7.48239 16.2134 8.2243 15.9061 8.77131 15.3591M10.8321 9.17322C11.103 9.44406 11.3179 9.7656 11.4645 10.1195C11.6111 10.4734 11.6865 10.8527 11.6865 11.2357C11.6865 11.6188 11.6111 11.9981 11.4645 12.3519C11.3179 12.7058 11.103 13.0274 10.8321 13.2982L8.76964 15.3607M6.70714 9.17322L4.64464 11.2357M15.3588 8.77155C15.9058 8.22454 16.2131 7.48264 16.2131 6.70905C16.2131 5.93546 15.9058 5.19356 15.3588 4.64655C14.8118 4.09954 14.0699 3.79224 13.2963 3.79224C12.5227 3.79224 11.7808 4.09954 11.2338 4.64655M9.17464 10.8332C8.90377 10.5624 8.68891 10.2408 8.54231 9.88695C8.39572 9.53306 8.32026 9.15377 8.32026 8.77072C8.32026 8.38767 8.39572 8.00838 8.54231 7.65449C8.68891 7.3006 8.90377 6.97906 9.17464 6.70822L11.2363 4.64572M13.298 10.8332L15.3605 8.77072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIconsLinkOutline);
export default __webpack_public_path__ + "static/media/bitcoin-icons_link-outline.a9fe2ce14a83ec693136c4209db98de2.svg";
export { ForwardRef as ReactComponent };